var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messages page"},[_c('magic-messages',{attrs:{"message-id":_vm.$route.params.messageId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }